import { useSelector } from "react-redux";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import { getActivePassenger } from "../../redux/QuoteSelectors";
import PickProductModalContainer from "../../containers/PickProductModalContainer/PickProductModalContainer";
import { isTravesiaCatedral } from "../../../../helpers/rentals";
import CardProducts from "./CardProducts";

const CardProductsWithModal = ({
  bundles = [],
  onClick,
  modalVisible,
  setModalVisible,
}) => {
  const supplierData = useSelector(getSupplierData);
  const activePassenger = useSelector(getActivePassenger);

  return (
    <>
      <PickProductModalContainer
        open={modalVisible.visible}
        type={modalVisible.type}
        selectedBundle={modalVisible.selectedBundle}
        closeModal={() =>
          setModalVisible({ visible: false, type: null, selectedBundle: null })
        }
        passengerId={activePassenger}
        visibleProductsByBundle={isTravesiaCatedral(supplierData._id)}
      />
      <CardProducts bundles={bundles} onClick={onClick} />
    </>
  );
};

export default CardProductsWithModal;
